import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  generateRewardPdfApi,
  getRewardsFiltersApi,
  getRewardsPhotoApi,
  getRewardsTasksApi,
  getRewardsUsersApi,
} from "../api/RewardsApi";

const initialState = {
  tasks: [],
  users: {},
  rewardPhotos: [],
  pdfResponse: "",
  filters: {},
  statusId: '',
  sortdir: '',
  sortby: '',

  loading: false,
  generateLoading: false,
};

export const getRewardsPhoto = createAsyncThunk(
  "reward/getRewardsPhoto",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getRewardsPhotoApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getRewardsFilters = createAsyncThunk(
  "reward/getRewardsFilters",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getRewardsFiltersApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getRewardsTasks = createAsyncThunk(
  "reward/getRewardsTasks",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getRewardsTasksApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getRewardsUsers = createAsyncThunk(
  "reward/getRewardsUsers",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getRewardsUsersApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const generateRewardPdf = createAsyncThunk(
  "reward/generateRewardPdf",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await generateRewardPdfApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

const rewardSlice = createSlice({
  name: "reward",
  initialState,
  reducers: {
    addStatus: (state, action) => {
      state.statusId= action.payload;
    },
    addSortDir: (state, action) => {
      state.sortdir= action.payload;
    },
    addSortBy: (state, action) => {
      state.sortby= action.payload;
    },
    clearAllFilter: (state, action) => {
      state.statusId= 0;
      state.sortby = '';
      state.sortdir = '';
    }
  },
  extraReducers: (builder) => {

    // get reward photos
    builder.addCase(getRewardsPhoto.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRewardsPhoto.fulfilled, (state, action) => {
      state.rewardPhotos = action.payload?.response;
      state.loading = false;
    });
    builder.addCase(getRewardsPhoto.rejected, (state) => {
      state.loading = false;
    });

    // get filters
    builder.addCase(getRewardsFilters.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRewardsFilters.fulfilled, (state, action) => {
      state.filters = action.payload?.response;
      state.loading = false;
    });
    builder.addCase(getRewardsFilters.rejected, (state) => {
      state.loading = false;
    });

    // get tasks
    builder.addCase(getRewardsTasks.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRewardsTasks.fulfilled, (state, action) => {
      state.tasks = action.payload?.response;
      state.loading = false;
    });
    builder.addCase(getRewardsTasks.rejected, (state) => {
      state.loading = false;
    });

    // get users
    builder.addCase(getRewardsUsers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRewardsUsers.fulfilled, (state, action) => {
      state.users = action.payload?.response;
      state.loading = false;
    });
    builder.addCase(getRewardsUsers.rejected, (state) => {
      state.loading = false;
    });

    // generate pdf
    builder.addCase(generateRewardPdf.pending, (state) => {
      state.generateLoading = true;
    });
    builder.addCase(generateRewardPdf.fulfilled, (state, action) => {
      state.pdfResponse = action?.payload;
      state.generateLoading = false;
    });
    builder.addCase(generateRewardPdf.rejected, (state) => {
      state.generateLoading = false;
    });
  },
});

export const {addStatus, addSortBy, addSortDir, clearAllFilter} = rewardSlice.actions;
export default rewardSlice.reducer;
